/**
 * @file brandScheme
 * @author lijie44 <lijie44@baidu.com>
 * @description 获取应用市场scheme
 */
const packageName = 'com.baidu.newapp';

export const REGEXP_HW = /huawei|honor/i;
export const REGEXP_OPPO = /oppo|heytap|p[a-z][a-z][a-z]\d0/i;
export const REGEXP_VIVO = /vivo|v\d\d\d\d[a-z]?a?/i;
export const REGEXP_MI = /mi|m2011k2c|2201122c|22011211c/i;

export const brandSchemeWithPackageName = (packageName: string) => (sUserAgent: string, isBaidu = false) => {
    if (REGEXP_HW.test(sUserAgent)) {
        return `appmarket://details?id=${packageName}`;
    }
    else if (REGEXP_OPPO.test(sUserAgent)) {
        return `oppomarket://details?packagename=${packageName}`;
    }
    else if (REGEXP_VIVO.test(sUserAgent)) {
        return `vivomarket://details?id=${packageName}`;
    }
    else if (REGEXP_MI.test(sUserAgent)) {
        // 挡在手百内，其他小米手机的scheme，在deeplink下无法打开小米市场指定包，估计是手百问题，先兜底处理
        return isBaidu ? '' : `mimarket://details?id=${packageName}`;
    }
    return '';
};

const brandScheme = brandSchemeWithPackageName(packageName);

export default brandScheme;
